<h1 class="access-denied">Access Denied</h1>
<span>
  Please submit an access request through the
  <a class="under-line-link" target="_blank"  [attr.href]="selfService">VIDA Access Control</a>
  system.
</span>